"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_THRESHOLD_STATUS = exports.STORE_CLEAR_DATA = exports.SUBMIT_ORDER = exports.GET_STORE_CATALOG = exports.STORE_LOAD_DATA = exports.INCREMENT_QTY = exports.STORE_REMOVE_ITEM = exports.DECREMENT_QTY = void 0;
const DECREMENT_QTY = 'store/DECREMENT_QTY';
exports.DECREMENT_QTY = DECREMENT_QTY;
const INCREMENT_QTY = 'store/INCREMENT_QTY';
exports.INCREMENT_QTY = INCREMENT_QTY;
const STORE_REMOVE_ITEM = 'store/REMOVE_ITEM';
exports.STORE_REMOVE_ITEM = STORE_REMOVE_ITEM;
const STORE_LOAD_DATA = 'store/LOAD_DATA';
exports.STORE_LOAD_DATA = STORE_LOAD_DATA;
const STORE_CLEAR_DATA = 'store/CLEAR_DATA';
exports.STORE_CLEAR_DATA = STORE_CLEAR_DATA;
const GET_STORE_CATALOG = 'store/GET_STORE_CATALOG';
exports.GET_STORE_CATALOG = GET_STORE_CATALOG;
const SUBMIT_ORDER = 'store/SUBMIT_ORDER';
exports.SUBMIT_ORDER = SUBMIT_ORDER;
const GET_THRESHOLD_STATUS = 'store/GET_THRESHOLD_STATUS';
exports.GET_THRESHOLD_STATUS = GET_THRESHOLD_STATUS;
//# sourceMappingURL=types.js.map